import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import personalCreditImage from "../../assets/static/personal/loan.png";

function CreditAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Credit Account? We’ve got you covered."
        description="Kontriman provides several ways to assist you with your credit account – through our help center, chat support, and email. Access the support you need, whenever and wherever you need it."
        imageUrl={FlightImage}
      />

      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Text column */}
              <Col
                md={6}
                className="order-1 order-md-2 d-flex align-items-center"
              >
                <div>
                  <h1 className="custom_heading">Personal Credit Account</h1>
                  <p>
                    Our Personal Credit Account is designed to provide flexible
                    access to funds when you need them most. Whether it's an
                    unexpected expense or a planned investment, we offer fair
                    terms and reliable service.
                  </p>

                  <h5 className="mt-4">Features & Benefits</h5>
                  <ul>
                    <li>Flexible repayment options</li>
                    <li>Competitive interest rates</li>
                    <li>Quick approval process</li>
                    <li>24/7 account access via online banking</li>
                  </ul>

                  <h5 className="mt-4">Eligibility</h5>
                  <ul>
                    <li>Valid national ID or passport</li>
                    <li>Proof of income or employment</li>
                    <li>Minimum age: 18 years</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">Apply Now</Button>
                  </a>
                </div>
              </Col>

              {/* Image column */}
              <Col md={6} className="order-2 order-md-1">
                <img
                  src={personalCreditImage}
                  alt="Personal Credit Account"
                  className="img-fluid"
                />
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default CreditAccount;
